import { EditTablePage } from "./lib/edit_table_page.js";

class AccountsCheapVpsPage {
  setup_edit_table_page() {
    this.edit_table_page = new EditTablePage('table', '/accounts/cheap_vps', '',
                                    () => this.on_table_loaded(),
                                    (row) => this.on_new_row()
                                  );
    this.edit_table_page.setup_hoster_filter();
  }

  on_table_loaded() {
    const updateManualPlanFields = (row, selectedPlan) => {
      row.find('.manual-plan-fields').prop('disabled', Boolean(selectedPlan));
      row.find('.manual-plan-param').prop('disabled', Boolean(selectedPlan));
      if (selectedPlan && row.hasClass('new-item')) {
        row.find('[name="ipv4"]').prop('checked', true);
      }
      if (selectedPlan?.cpu_type) {
        row.find('[name="cpu_type"]').val(selectedPlan.cpu_type);
      }
      if (selectedPlan && !row.find('[name="url"]').val()) {
        row.find('[name="url"]').val(selectedPlan.url);
      }
      if (selectedPlan && !row.find('[name="locations"]').val()) {
        row.find('[name="locations"]').val(selectedPlan.locations);
      }
    };

    const updateProviderFields = (row, hosterId) => {
      row.find('.provider-logo-param').prop('disabled', Boolean(hosterId));
    };

    const loadPlanOptions = (row, hosterId) => {
      if (!hosterId) {
        return;
      }
      const planSelect = row.find('.plan-select');
      $.getJSON('/accounts/cheap_vps/plans', { hoster_id: hosterId }, (plans) => {
        if (row.find('.hoster-select').val() !== hosterId) {
          return;
        }
        plans.forEach((plan) => {
          let option = planSelect.find('option').filter((index, element) => element.value === String(plan.id));
          if (!option.length) {
            option = $(new Option(plan.name, plan.id));
            planSelect.append(option);
          }
          option.data('url', plan.url);
          option.data('locations', plan.locations);
          option.data('cpu-type', plan.cpu_type);
        });
      });
    };

    $('table#edit-table .edit-item-row').each((index, row) => {
      const editRow = $(row);
      const selectedPlan = editRow.find('.plan-select option:selected');
      updateProviderFields(editRow, editRow.find('.hoster-select').val());
      updateManualPlanFields(editRow, selectedPlan.val() ? {
        url: selectedPlan.data('url'),
        locations: selectedPlan.data('locations'),
        cpu_type: selectedPlan.data('cpu-type')
      } : null);
      loadPlanOptions(editRow, editRow.find('.hoster-select').val());
    });

    $('table#edit-table').off('change.cheap-vps', '.hoster-select').on('change.cheap-vps', '.hoster-select', (event) => {
      var hosterSelect = $(event.currentTarget);
      var editRow = hosterSelect.closest('tr');
      var planSelect = editRow.find('.plan-select');
      var hosterId = hosterSelect.val();

      if (editRow.hasClass('new-item')) {
        editRow.find('[name="ddos_protection"]').prop('checked', hosterSelect.find('option:selected').data('ddos-protection') === true);
      }
      planSelect.empty().append(new Option('Select a plan', ''));
      planSelect.prop('disabled', !hosterId);
      updateProviderFields(editRow, hosterId);
      updateManualPlanFields(editRow, null);
      loadPlanOptions(editRow, hosterId);
    });

    $('table#edit-table').off('change.cheap-vps-plan', '.plan-select').on('change.cheap-vps-plan', '.plan-select', (event) => {
      const planSelect = $(event.currentTarget);
      const selectedPlan = planSelect.find('option:selected');
      updateManualPlanFields(planSelect.closest('tr'), selectedPlan.val() ? {
        url: selectedPlan.data('url'),
        locations: selectedPlan.data('locations'),
        cpu_type: selectedPlan.data('cpu-type')
      } : null);
    });
  }

  on_new_row() {
  }

  load_cheap_vps(pattern, page) {
    this.edit_table_page.load_table(pattern, page);
  }

  setup_reset_filter_callback(){
    this.edit_table_page.setup_reset_filter_callback();
  }

  setup_pagination() {
    this.edit_table_page.setup_pagination();
  }
}

$(document).on('turbo:load', function() {
  if ($("body.accounts_cheap_vps.index").length == 0) {
    return;
  }
  console.log("page load in accounts_cheap_vps.js");

  var page = new AccountsCheapVpsPage();
  page.setup_edit_table_page();
  page.load_cheap_vps();
  page.setup_pagination();
  page.setup_reset_filter_callback();
} );
